import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCollectionCatalogItemById } from '@/redux/actions';
import { useSSRSelector } from '@/redux/ssrStore';
import LocalStorageHelper from '../../utils/LocalStorageHelper';
import { isTimerExpired } from '@/utils/isTimerExpired';
import { COLLECTION_CATALOG_ITEMS } from '@/utils/constants';
import FlatList from '@/components/FlatList';
import PromoSlider from 'src/components/CouponsAndVouchers/PromoSlider';
import { PROMO_APPLICABILITY_TYPES } from 'src/constants/promos';
import { ProductListWrapper } from 'src/components/DesignSystem/Widgets2.0/ProductListWrapper';

const CollectionCategory = () => {
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    setActiveCategoryId(router?.query?.cid);
  }, [router?.query?.cid]);

  const collections = useSSRSelector((state) => state.catalogReducer.collections);
  const storeCollection = collections?.filter(
    (collection) => collection.id === +router.query.collectionId
  );

  const collection = storeCollection?.length > 0 ? storeCollection[0] : null;

  const { collectionCatalogItems } = useSelector((state: any) => ({
    collectionCatalogItems: state.catalogReducer.collectionCatalogItems,
  }));

  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));

  /**
   * @return collectionCatalogItems from localstorage if it exists and within the cache clear time interval, else it will return from redux store.
   */
  const fetchCollectionCatalogItems = () => {
    const storedCollectionCatalogItems = LocalStorageHelper.get(COLLECTION_CATALOG_ITEMS);

    if (storedCollectionCatalogItems && !isTimerExpired()) {
      return JSON.parse(storedCollectionCatalogItems);
    }

    return collectionCatalogItems;
  };

  const returnNestedCollectionData = (collectionId, categoryId) => {
    const collectionCatalogItemList = fetchCollectionCatalogItems();
    const collectionIdValue = collectionCatalogItemList[collectionId];
    if (collectionIdValue) {
      return collectionIdValue[categoryId];
    }
    return null;
  };

  const loadMoreData = (category, collection) => {
    if (storeData?.store_id) {
      dispatch(
        fetchCollectionCatalogItemById({
          storeId: storeData.store_id,
          collectionId: collection?.id,
          categoryId: category?.id,
        })
      );
    }
  };

  return (
    <article className="collections-main">
      <section className="collections-body center">
        <div key={collection?.id}>
          <h2 data-id={collection?.id} className="collection-heading tc">
            {collection?.name}
          </h2>
          <PromoSlider
            type={PROMO_APPLICABILITY_TYPES.COLLECTION}
            typeId={collection?.id}
          />
          {collection?.categories
            ?.filter((category) => `${category.id}` === `${activeCategoryId}`)
            ?.map((category) => (
              <div
                key={category.id}
                data-id={category.id}
                className="category-items-section"
                id={category.id}
              >
                <h3 className="category-item-header">{category.name}</h3>
                {/* <div className="category-item-body"> */}
                <div className="md:pt-[20px] pb-[24px] tw-pt-[10px]">
                  <FlatList
                    isLoaderVisible={false}
                    isNext={
                      returnNestedCollectionData(collection.id, category.id)
                        ? false
                        : true
                    }
                    onScrollEnd={() => loadMoreData(category, collection)}
                    renderInsideFragment
                    // add LoaderComponent for loading sections
                    renderList={() => {
                      return (
                        <ProductListWrapper
                          productList={returnNestedCollectionData(
                            collection.id,
                            category.id
                          )}
                          oldCardConfigs={{
                            showButton: true,
                            noTagsReadState: 'fromLength',
                          }}
                        />
                      );
                    }}
                  ></FlatList>
                </div>
              </div>
            ))}
        </div>
      </section>
    </article>
  );
};

export default CollectionCategory;
